<script>
  import { onMount } from 'svelte';

  let { container, onClickOffHandler = () => {} } = $props();

  onMount(() => {
    const clickHandler = (event) => {
      let elem = event.target;

      while (elem !== document.body) {
        if (elem === container) return;
        if (!elem) break;
        elem = elem.parentElement;
      }
      onClickOffHandler();
    };
    window.addEventListener('click', clickHandler);

    return () => {
      window.removeEventListener('click', clickHandler);
    };
  });
</script>
